"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraceContext = void 0;
const utilities_1 = require("../../utilities");
class TraceContext {
    constructor(version, traceId, requestId, flags, state) {
        this.version = version;
        this.traceId = traceId;
        this.requestId = requestId;
        this.flags = flags;
        this.state = state;
    }
    toTraceParent() {
        return `${this.version}-${this.traceId}-${this.requestId}-${this.flags}`;
    }
    toTraceState() {
        const entries = Object.entries(this.state).map(([k, v]) => `${k}=${v}`);
        const state = entries.join(',');
        return state;
    }
    toCorrelation() {
        return {
            traceId: this.traceId,
            requestId: this.requestId
        };
    }
    static parseStringOrNew(traceParentMaybe, traceStateMaybe) {
        if (!this.isValid(traceParentMaybe)) {
            return this.new();
        }
        return this.parseString(traceParentMaybe, traceStateMaybe);
    }
    static parseString(traceParentMaybe, traceStateMaybe) {
        if (!this.isValid(traceParentMaybe)) {
            throw new utilities_1.Exception('invalid-trace-parent');
        }
        const pieces = traceParentMaybe.split('-');
        const version = pieces[0];
        const traceId = pieces[1];
        const requestId = pieces[2];
        const flags = pieces[3];
        const state = {};
        if (traceStateMaybe) {
            const parsedData = decodeURIComponent(traceStateMaybe).split(',');
            for (let data of parsedData) {
                const [key, value] = data.split('=');
                state[key] = value;
            }
        }
        return new TraceContext(version, traceId, requestId, flags, state);
    }
    static fromTraceIdAndRequestId(traceId, requestId) {
        const version = '00';
        const flags = '00';
        const state = {};
        return new TraceContext(version, traceId, requestId, flags, state);
    }
    static new() {
        const version = '00';
        const traceId = utilities_1.Guid.next().toAlphaNumericString();
        const requestId = utilities_1.Guid.next().toAlphaNumericString().substring(0, 16);
        const flags = '00';
        const state = {};
        return new TraceContext(version, traceId, requestId, flags, state);
    }
    static isValid(traceMaybe) {
        return /^[\da-f]{2}-[\da-f]{32}-[\da-f]{16}-[\da-f]{2}$/.test(traceMaybe);
    }
}
exports.TraceContext = TraceContext;
//# sourceMappingURL=trace-context.js.map